import theme from 'themes';
import moment from 'moment';
import { ProteinMachineCategoryStates } from 'types/protein';

export const getDurationInMs = (label: string, value: number, startTime: string | Date, endTime: string | Date, showTotalNumberOfHours?: boolean) => {
  value = Number(value);
  const days = calculateDaysInRange({ startTime, endTime });

  // Calculate total hours from milliseconds
  const totalHours = value ? (value / (1000 * 60 * 60)) : 0;

  // Calculate average hours per day
  let averageHoursPerDay = showTotalNumberOfHours ? totalHours : totalHours / days;

  if (label?.toLowerCase() !== 'running' && averageHoursPerDay !== 0) {
    averageHoursPerDay = -averageHoursPerDay;
  }

  return Number(averageHoursPerDay.toFixed(2));
}

const getMax = (arr: number[]) => {
    let len = arr.length;
    let max = -Infinity;
  
    while (len--) {
      max = arr[len] > max ? arr[len] : max;
    }
    return max;
};
  
const getMin = (arr: number[]) => {
    let len = arr.length;
    let min = Infinity;

    while (len--) {
        min = arr[len] < min ? arr[len] : min;
    }
    return min;
};

export const getYaxisOffset = (series: { y: any; }[]): { min: number; max: number } => {
  const ys = series.map((s: { y: any; }) => s.y) as number[];
  const isYsNumber = ys.every((y) => typeof y === 'number');
  return {
    min: isYsNumber ? getMin(ys) : 0,
    max: isYsNumber ? getMax(ys) : 0
  };
};

export const ColorData = Object.freeze({
    Running: theme.colors.machineUtilizationColors.run,
    Cleaning: theme.colors.machineUtilizationColors.clean,
    Idle: theme.colors.machineUtilizationColors.idle,
    Paused: theme.colors.machineUtilizationColors.stopped,
    'Stop Alarm': theme.colors.machineUtilizationColors.stopByAlarm,
    Service: theme.colors.machineUtilizationColors.service
});

export const ColorDataByCode = Object.freeze({
  [ProteinMachineCategoryStates.Running]: theme.colors.machineUtilizationColors.run,
  [ProteinMachineCategoryStates.Cleaning]: theme.colors.machineUtilizationColors.clean,
  [ProteinMachineCategoryStates.Idle]: theme.colors.machineUtilizationColors.idle,
  [ProteinMachineCategoryStates.Stop]: theme.colors.machineUtilizationColors.stopped,
  [ProteinMachineCategoryStates.StopByAlarm]: theme.colors.machineUtilizationColors.stopByAlarm
});

export const calculateDaysInRange = ({ startTime, endTime }: { startTime: string | Date, endTime: string | Date }): number => {
  const start = moment(startTime);
  const end = moment(endTime);
  const duration = moment.duration(end.diff(start));
  const days = duration.asDays();

  return days < 1 ? 1 : Math.ceil(days);
};

export const calculateAdjustedTarget = (
  targetValue: number | undefined,
  startTime: Date,
  endTime: Date
): number => {
  if (!targetValue) return 0;

  const start = new Date(startTime);
  const end = new Date(endTime);
  const diffInMs = end.getTime() - start.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  console.log(diffInDays, 'diffInDays');
  console.log(diffInMs, 'diffInMs');

  // targetValue is weekly hours, so calculate proportionally based on days
  const targetPerDay = targetValue / 7;

  return targetPerDay * diffInDays;
};
